import { PureComponent } from 'react'
import PropTypes from 'prop-types'

import styles from './FictivLogo.css'

export default class FictivLogo extends PureComponent {
    static get propTypes() {
        return {
            fill: PropTypes.oneOf(['white', 'gray']),
        }
    }
    render() {
        const { fill = 'default' } = this.props

        return (
            <svg
                className={styles[fill]}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 92 40"
            >
                <title>Fictiv</title>
                <path d="M15.8,11.79H6.93V29.61h-4V11.79H0.31V8.54H2.93V7.83c0-7,5.24-7.83,7.91-7.83a8.68,8.68,0,0,1,1.53.12V3.58a5.84,5.84,0,0,0-1-.08c-1.53,0-4.42.5-4.42,4.42V8.54H19.84V29.61h-4V11.79Zm0-11.58h4.08V4.33H15.76V0.21Z" />
                <path d="M36,8a10.72,10.72,0,0,1,7.91,3.05L42,13.92a8.54,8.54,0,0,0-5.83-2.42A7.18,7.18,0,0,0,28.79,19a7.3,7.3,0,0,0,7,7.57h0.43a9.55,9.55,0,0,0,6.49-2.83l1.63,3A11.54,11.54,0,0,1,36,30.08c-6.62,0-11.29-4.71-11.29-11S29.34,8,36,8Z" />
                <path d="M49.81,12.08H47.06V8.83h2.88V2.72h3.91v6.1H59v3.25h-5.1v9.37c0,4.2,3,4.75,4.49,4.75a4.85,4.85,0,0,0,1-.08v3.58a11.1,11.1,0,0,1-1.42.08c-2.71,0-8.1-.83-8.1-7.87V12.08Z" />
                <path d="M63.82,0.21H67.9V4.33H63.82V0.21Zm0,8.33h4V29.61h-4V8.54Z" />
                <path d="M71.36,8.54h4.29l5.12,14.25c0.42,1.17.66,2.88,0.71,2.88h0.08s0.34-1.71.76-2.88L87.44,8.54h4.25l-7.8,21.07H79.23Z" />
            </svg>
        )
    }
}
